export default [
    {
        path: '/partners-report',
        name: 'PagePartnerReportList',
        meta: { title: 'partnerReport.listTitle', roles: ['ADMIN', 'TEAM_LEADER'], permissions: ['partner_report'] },
        component: () => import('@/pages/partner-report'),
    },
]